import styled from "styled-components";

const MessageWrapper = styled.div`
  background-color: #405dae;
  color: white;
  padding: 12px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  max-width: 70%;
`;

export function UserMessage({message}: {message: string}) {
  return (
    <div className="flex justify-end">
      <MessageWrapper>{message}</MessageWrapper>
    </div>
  );
}
